import NewspaperLink from './NewspaperLink'
export default NewspaperLink
